import React from 'react';
import Navbar from '../navigation/Navbar';


const Base = ({className = "", children, bgClass }) => {

    let currentYear = document.getElementsByClassName("copyrightyear").innerHTML;
    currentYear = new Date().getFullYear();

    return (
        <>
            <div className={`${bgClass ? bgClass : ""}`}>
                <Navbar />
                <div className='container mx-auto'>
                    <div className={className}>
                        {children}
                    </div>
                </div>
                <footer className="footer  w-full bottom-0 pt-4    text-xs    xs:text-xs    sm:text-sm   md:text-sm    smLaptop:text-base    lg:text-base    xl:text-base">
                    <div className="container">
                        <span className="text-muted">
                            Never miss a <span className="text-[#456799]">Task</span> again!
                        </span>
                    </div>
                    <div className="container-fluid text-white text-center">
                        <div className='bg-[#5f7ac2]'>
                            <p>Copyright &copy; <span className="copyrightyear">{currentYear}</span> TodoMate</p>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    )
}



export default Base;